export default __webpack_public_path__ + "static/25-812d456cd65554ebc597484becfa0f80.jpg";